import { render, staticRenderFns } from "./ProductionBatch.vue?vue&type=template&id=70f8603c&"
import script from "./ProductionBatch.vue?vue&type=script&lang=js&"
export * from "./ProductionBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports